import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *   requestedUserId: string,
 *   size: number, (1)
 *   scheduleName: string
 * } queryParam
 * @returns Promise
 */
export const getLatestFirmwareUpdateDetails = (queryParam) => {
  /**End Point:- getLatestFirmwareUpdateDetails**/
  return axiosInstance.post(
    backendConfig.API_URL +
      backendConfig.API_END_POINTS.getLatestFirmwareUpdateDetails,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   size: number, (1)
 *   scheduleName: string
 *   requestedUserId: string,
 *   deviceId: string,
 *   filters: {
 *        ------ For update history table  -------
 *       otaStatus: ["Success","Failed"]
 *        ------ For update progress table  -------
 *       otaStatus: ["UpdateInProgress","DownloadStarted","DownloadingUpdates","DownloadingCompleted","DeviceMovedToStandby","InstallingUpdates","InstallingCompleted","DeviceRestarting", "Success","Failed"]
 *
 *    },
 *   size: number
 * } queryParam
 * @returns Promise
 */
export const getDeviceFirmwareUpdateHistoryDetails = (queryParam) => {
  /**End Point:- getDeviceFirmwareUpdateHistoryDetails**/
  return axiosInstance.post(
    backendConfig.API_URL +
      backendConfig.API_END_POINTS.getDeviceFirmwareUpdateHistoryDetails,
    queryParam
  );
};

/**
 * @param {
 *   releaseVersion: "<release version>",
 *  deviceList: ["deviceid"],
 * } queryParam
 * @returns Promise
 */
export const initiateOTAUpgrade = (queryParam) => {
  /**End Point:- performOtaUpgrade**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.performOtaUpgrade,
    queryParam
  );
};
